import { useEffect, useState } from "react";
import { Moon, Pause, Sun, Volume2 } from "lucide-react";
import { useTheme } from "../../theme/ThemeProvider";

export const ThemeToggle = ({ className = "" }) => {
  const { theme, toggle } = useTheme();
  const dark = theme === "dark";
  return (
    <button data-testid="theme-toggle" onClick={toggle} aria-label={dark ? "Activer le mode clair" : "Activer le mode sombre"} aria-pressed={dark}
      className={`flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-white/5 text-white transition-colors hover:bg-white/10 ${className}`}>
      {dark ? <Sun className="h-5 w-5 text-[#E0B33A]" /> : <Moon className="h-5 w-5" />}
    </button>
  );
};

const synth = typeof window !== "undefined" ? window.speechSynthesis : null;

/** Reads key content aloud (low-literacy support) with the device French voice. */
export const ReadAloud = ({ text, testId = "read-aloud-button", tone = "light", label = "Écouter" }) => {
  const [speaking, setSpeaking] = useState(false);
  useEffect(() => () => synth?.cancel(), []);
  if (!synth) return null;
  const play = () => {
    if (speaking) { synth.cancel(); setSpeaking(false); return; }
    synth.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.lang = "fr-FR"; u.rate = 0.92;
    const v = synth.getVoices().find((x) => x.lang?.startsWith("fr"));
    if (v) u.voice = v;
    u.onend = u.onerror = () => setSpeaking(false);
    setSpeaking(true);
    synth.speak(u);
  };
  const cls = tone === "dark" ? "bg-white/10 text-white hover:bg-white/15" : "bg-[#0A2540]/5 text-[#0A2540] hover:bg-[#0A2540]/10";
  return (
    <button type="button" data-testid={testId} onClick={play} onPointerDown={(e) => e.stopPropagation()} aria-pressed={speaking} aria-label={speaking ? "Arrêter la lecture" : `${label || "Écouter"} : lecture audio`}
      className={`inline-flex h-12 min-w-12 items-center justify-center gap-2 rounded-full px-4 text-sm font-bold transition-colors ${cls}`}>
      {speaking ? <Pause className="h-5 w-5" /> : <Volume2 className="h-5 w-5" />}{label && <span>{speaking ? "Stop" : label}</span>}
    </button>
  );
};

export const Shimmer = ({ className = "" }) => <div aria-hidden className={`shimmer rounded-2xl ${className}`} />;

export const PageSkeleton = () => (
  <div data-testid="page-skeleton" role="status" aria-label="Chargement" className="space-y-6">
    <Shimmer className="h-10 w-72" />
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">{[0, 1, 2, 3].map((i) => <Shimmer key={i} className="h-28" />)}</div>
    <div className="grid gap-6 lg:grid-cols-3"><Shimmer className="h-72 lg:col-span-2" /><Shimmer className="h-72" /></div>
  </div>
);
